import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stats",
  "use": "icon-stats-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-stats\"><path d=\"M16.051 19V7.093c0-.565.452-1.023 1.01-1.023s1.01.458 1.01 1.023V19h.919c.558 0 1.01-.458 1.01-1.023V4.023C20 3.458 19.548 3 18.99 3H3.01C2.452 3 2 3.458 2 4.023v13.954C2 18.542 2.452 19 3.01 19h.919v-5.767c0-.566.452-1.024 1.01-1.024s1.01.458 1.01 1.024V19h2.02v-5.767c0-.566.453-1.024 1.01-1.024.559 0 1.01.458 1.01 1.024V19h2.021v-7.814c0-.565.452-1.023 1.01-1.023s1.01.458 1.01 1.023V19h2.021zM3.025 1h15.95C20.645 1 22 2.368 22 4.056v13.888C22 19.632 20.646 21 18.975 21H3.025C1.355 21 0 19.632 0 17.944V4.056C0 2.368 1.354 1 3.025 1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-stats.svg
// module id = 891
// module chunks = 74